import React, { Component } from 'react';
import { FormGroup, FormControl, ControlLabel, Col } from 'react-bootstrap';
import Api from './../../../Global/Modules/Api'

class FactuurAdres extends Component {
    constructor(props) {
        super(props)
    }


    render() {
        const data = this.props.data

        return (
            <div>
                {/*
                    TODO: For all adresses: Add postcode + nr check and autofill address, this should not add to addresses outside netherlands.
                */}
                <h5>Factuuradres</h5>
                <FormGroup controlId="AccountFactuurAdres">
                    <Col componentClass={ControlLabel} sm={4}>
                        Adres
                    </Col>
                    <Col sm={6}>
                        {data.invoiceAddress}
                    </Col>
                </FormGroup>

                <FormGroup controlId="AccountFactuurPostcode">
                    <Col componentClass={ControlLabel} sm={4}>
                        Postcode
                    </Col>
                    <Col sm={6}>
                        {data.invoicePostCode}
                    </Col>
                </FormGroup>

                <FormGroup controlId="AccountFactuurPlaats">
                    <Col componentClass={ControlLabel} sm={4}>
                        Plaats
                    </Col>
                    <Col sm={6}>
                        {data.invoiceCity}
                    </Col>
                </FormGroup>
                <FormGroup controlId="AccountFactuurEmail">
                    <Col componentClass={ControlLabel} sm={4}>
                        Mail
                    </Col>
                    <Col sm={6}>
                        {data.invoiceEmail}
                    </Col>
                </FormGroup>
            </div>
        );
    }
}

export default FactuurAdres;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Account/FactuurAdres.js